import Case from 'assets/icons/case.svg';
import Finens from 'assets/icons/finens.svg';
import Crypto from 'assets/icons/crypto.svg';
import Company from 'assets/icons/Company.svg';
import FinInvest from 'assets/icons/finInvest.svg';

const gap = { gap: { tablet: '10px', laptop: '20px' } };

export const finTechTechExpertData = {
  title: (
    <>
      Программные решения
      <br />и услуги для финансовой сферы
    </>
  ),
  titleProps: { fontSize: { mobile: '28px', tablet: '36px', laptop: '48px' } },
  tabTitleProps: { fontSize: { mobile: '18px', laptop: '20px' } },

  cardsData: [
    {
      title: 'Для банков',
      titleProps: { fontSize: '24px' },
      tabIcon: Case,
      content:
        'Команда ASTON готова предложить своим клиентам аудит качества, разработку мобильных приложений, высоконагруженных платформ, операционного клиентского офиса и различных систем для повышения клиентской лояльности. Опыт наших экспертов позволит реализовать любые нестандартные решения',
      contentProps: { fontSize: '10px' },
      gap,
    },
    {
      title: 'Для финансового сектора',
      titleProps: { fontSize: '24px' },
      tabIcon: Finens,
      content:
        'ASTON — эксперт в разработке ПО для финансового сектора. В компании работает более 150 сотрудников с опытом в финансовой сфере, способных реализовать проект с нуля и довести его до выхода на рынок. Мы работаем с инвестиционными фондами, банками, и страховыми компаниями',
      gap,
    },
    {
      title: 'Для инвестиционно-брокерского бизнеса',
      titleProps: { fontSize: '24px' },
      tabIcon: FinInvest,
      content:
        'В портфеле Aston множество проектов для российских компаний. Наши решения позволяют эффективно управлять инвестиционным портфелем, контролировать прибыльность и повышать уровень удовлетворённости клиентов. Наш уровень экспертизы подтверждают показатели',
      gap,
    },
    {
      title: 'Для страховых компаний',
      titleProps: { fontSize: '24px' },
      tabIcon: Company,
      content:
        'Программное обеспечение от команды ASTON поможет вам делать правильные прогнозы и расчёты, одновременно снижая риски. Разработка современных цифровых решений в страховой сфере — наше ключевое преимущество',
      gap,
    },
    {
      title: 'Для лизинговых компаний',
      titleProps: { fontSize: '24px' },
      tabIcon: Crypto,
      content:
        'Наши специалисты готовы разработать и внедрить систему управления взаимоотношениями с клиентами (CRM), мобильные приложения и другие цифровые продукты для компаний, ведущих лизинговую деятельность. Благодаря нашему программному обеспечению вы сможете улучшить клиентский опыт, упростить планирование и управление запасами',
      gap,
    },
  ],
};
